import script from "./ObservationHistoryChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObservationHistoryChart.vue?vue&type=script&setup=true&lang=ts"

import "./ObservationHistoryChart.vue?vue&type=style&index=0&id=0291ac8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0291ac8c"]])

export default __exports__